var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 200,
    viewBox: "0 0 169 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3614_613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.015 31.1262L69.6042 0.44158C65.9686 -0.753003 61.9825 0.532258 59.7215 3.62319L1.70179 83.061C-0.555195 86.1519 -0.567012 90.3468 1.67027 93.4495L59.2213 173.23C61.4586 176.333 65.4408 177.642 69.0843 176.471L85.4464 171.204C88.4478 170.238 91.7407 170.948 94.0765 173.069L121.964 198.352C125.591 201.644 131.421 199.767 132.453 194.973L140.386 158.158C141.052 155.071 143.309 152.575 146.314 151.61L162.676 146.342C166.316 145.171 168.789 141.785 168.801 137.957L169.092 39.5553C169.104 35.7271 166.65 32.3247 163.015 31.1341V31.1262Z",
    fill: "#AFCA0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3614_613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.76c67cbe4d8c0f66188c0dbcadd3f1e8.svg";
export { ForwardRef as ReactComponent };